import { Table } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getSingleLeaveAllocation } from "../../redux/rtk/features/leave/leaveSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

function CustomTable({ list }) {
	const [columnsToShow, setColumnsToShow] = useState([]);

	console.log("list allocate p", list);

	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
		},
		// {
		//     id: 2,
		//     title: "Leave Type",
		//     dataIndex: "leaveType",
		//     key: "leaveType",
		//     render: (leaveType) => leaveType?.leaveType || "N/A", // Display the leaveType's name, or "N/A" if not available
		// },
		{
			id: 2,
			title: "Leave Type",
			dataIndex: "leavePolicy",
			key: "leavePolicy",
			render: (leavePolicy) => leavePolicy?.name
				? leavePolicy.name // Safely call .toLowerCase()
				: "N/A", // Fallback when leaveType is undefined or null
		},
		{
			id: 3,
			title: "Total Leave",
			dataIndex: "annualLeave",
			key: "annualLeave",
			render: (annualLeave) => annualLeave ? annualLeave : "-"
		},

		{
			id: 4,
			title: "Pending Leaves",
			dataIndex: "pendingLeaves",
			key: "pendingLeaves",
			render: (pendingLeaves) => pendingLeaves ? pendingLeaves : "-"

		},
	];

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	// Add a `key` and `serial` property to each item for rendering in the table
	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

	return (
		<div className="ant-card p-4 rounded mt-5">
			{/* <div className="flex my-2 justify-between">
				<div className="w-50">
					<h4 className="text-2xl mb-2">My Leave Allocations</h4>
				</div>
				{list && (
					<div className="flex justify-end mr-4">
						<div className="mt-0.5">
							<CsvLinkBtn>
								<CSVLink
									data={list}
									className="btn btn-dark btn-sm"
									style={{ marginTop: "5px" }}
									filename="leave_allocations"
								>
									Download CSV
								</CSVLink>
							</CsvLinkBtn>
						</div>
					</div>
				)}
			</div> */}
			{/* {list && (
				<div style={{ marginBottom: "30px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
				</div>
			)} */}
			<Table
				className="text-center"
				scroll={{ x: true }}
				list={list}
				columns={columnsToShow}
				dataSource={list ? addKeys(list) : []}
			/>
		</div>
	);
}

const LeaveAllocation = ({ userId, validityId }) => {
	// const { id } = useParams();
	// const userId = getUserFromToken();
	const dispatch = useDispatch();

	const rawList = useSelector((state) => state.leave.leave);
	console.log('allocate>>>>>', rawList);
	
	// Filter list based on validity_id
	const list = rawList ? rawList.filter((item) => {
		if (validityId) {
			return item?.leavePolicy?.validity_id === validityId;
		}
		return true; // Show all if no validity_id filter
	}) : [];


	useEffect(() => {
		if (userId) {
			console.log("userId", userId);
			dispatch(getSingleLeaveAllocation(userId));
		}
	}, [userId, dispatch]);

	return (
		<UserPrivateComponent permission={"readSingle-leaveApplication"}>
			<div className="card">
				<div className="card-body">
					<CustomTable list={list} />
				</div>
			</div>
		</UserPrivateComponent>
	);
};

export default LeaveAllocation;
